<div class="custom-date-range">
  <div class="custom-date-range__sidebar">
    @for (preset of presets(); track preset.id) {
      <button
        type="button"
        class="custom-date-range__preset"
        [attr.aria-pressed]="isPresetActive(preset)"
        [class.custom-date-range__preset--active]="isPresetActive(preset)"
        (click)="selectPreset(preset)"
      >
        {{ preset.labelKey | translateLang }}
      </button>
    }
    <button
      type="button"
      class="custom-date-range__preset"
      [attr.aria-pressed]="isCustomActive()"
      [class.custom-date-range__preset--active]="isCustomActive()"
      (click)="markCustom()"
    >
      {{ 'date_range.custom' | translateLang }}
    </button>
  </div>

  <div class="custom-date-range__main">
    <div class="custom-date-range__inputs">
      <div class="custom-date-range__field">
        <label class="custom-date-range__field-label">{{
          'date_range.start_date' | translateLang
        }}</label>
        <input
          type="text"
          inputmode="numeric"
          class="custom-date-range__field-input"
          [class.custom-date-range__field-input--invalid]="startErrorKey()"
          [placeholder]="'date_range.date_placeholder' | translateLang"
          [value]="startInputValue()"
          (input)="onStartInputChange($any($event.target).value)"
        />
        @if (startErrorKey(); as errorKey) {
          <small class="custom-date-range__field-error">{{ errorKey | translateLang }}</small>
        }
      </div>
      <div class="custom-date-range__field">
        <label class="custom-date-range__field-label">{{
          'date_range.end_date' | translateLang
        }}</label>
        <input
          type="text"
          inputmode="numeric"
          class="custom-date-range__field-input"
          [class.custom-date-range__field-input--invalid]="endErrorKey()"
          [placeholder]="'date_range.date_placeholder' | translateLang"
          [value]="endInputValue()"
          (input)="onEndInputChange($any($event.target).value)"
        />
        @if (endErrorKey(); as errorKey) {
          <small class="custom-date-range__field-error">{{ errorKey | translateLang }}</small>
        }
      </div>
    </div>

    <div class="custom-date-range__calendars">
      <div class="custom-date-range__month">
        <div class="custom-date-range__month-head">
          <button
            type="button"
            class="custom-date-range__nav"
            [attr.aria-label]="'date_range.previous_month' | translateLang"
            (click)="prevMonth('left')"
          >
            <app-icon name="chevron-left" [size]="16" color="currentColor" />
          </button>
          <span class="custom-date-range__month-label">{{ leftMonthLabel() }}</span>
          <button
            type="button"
            class="custom-date-range__nav"
            [attr.aria-label]="'date_range.next_month' | translateLang"
            [disabled]="isLeftNextDisabled()"
            (click)="nextMonth('left')"
          >
            <app-icon name="chevron-right" [size]="16" color="currentColor" />
          </button>
        </div>
        <div class="custom-date-range__grid">
          @for (day of DAYS; track day) {
            <div class="custom-date-range__weekday">{{ day }}</div>
          }
          @for (cell of leftDays(); track cell?.date?.getTime() ?? $index) {
            @if (cell) {
              <div
                class="custom-date-range__cell"
                [class.custom-date-range__cell--in-range]="cell.inRange"
                [class.custom-date-range__cell--range-start]="cell.showRangeStartHalf"
                [class.custom-date-range__cell--range-end]="cell.showRangeEndHalf"
              >
                <button
                  type="button"
                  class="custom-date-range__day"
                  [class.custom-date-range__day--today]="cell.isToday"
                  [class.custom-date-range__day--selected]="cell.isSelected"
                  [disabled]="cell.isDisabled"
                  (click)="onDayClick(cell)"
                  (mouseenter)="onDayHover(cell.date)"
                  (mouseleave)="onDayHover(null)"
                >
                  {{ cell.day }}
                </button>
              </div>
            } @else {
              <div class="custom-date-range__cell"></div>
            }
          }
        </div>
      </div>

      <div class="custom-date-range__month custom-date-range__month--right">
        <div class="custom-date-range__month-head">
          <button
            type="button"
            class="custom-date-range__nav"
            [attr.aria-label]="'date_range.previous_month' | translateLang"
            (click)="prevMonth('right')"
          >
            <app-icon name="chevron-left" [size]="16" color="currentColor" />
          </button>
          <span class="custom-date-range__month-label">{{ rightMonthLabel() }}</span>
          <button
            type="button"
            class="custom-date-range__nav"
            [attr.aria-label]="'date_range.next_month' | translateLang"
            [disabled]="isRightNextDisabled()"
            (click)="nextMonth('right')"
          >
            <app-icon name="chevron-right" [size]="16" color="currentColor" />
          </button>
        </div>
        <div class="custom-date-range__grid">
          @for (day of DAYS; track day) {
            <div class="custom-date-range__weekday">{{ day }}</div>
          }
          @for (cell of rightDays(); track cell?.date?.getTime() ?? $index) {
            @if (cell) {
              <div
                class="custom-date-range__cell"
                [class.custom-date-range__cell--in-range]="cell.inRange"
                [class.custom-date-range__cell--range-start]="cell.showRangeStartHalf"
                [class.custom-date-range__cell--range-end]="cell.showRangeEndHalf"
              >
                <button
                  type="button"
                  class="custom-date-range__day"
                  [class.custom-date-range__day--today]="cell.isToday"
                  [class.custom-date-range__day--selected]="cell.isSelected"
                  [disabled]="cell.isDisabled"
                  (click)="onDayClick(cell)"
                  (mouseenter)="onDayHover(cell.date)"
                  (mouseleave)="onDayHover(null)"
                >
                  {{ cell.day }}
                </button>
              </div>
            } @else {
              <div class="custom-date-range__cell"></div>
            }
          }
        </div>
      </div>
    </div>

    <div class="custom-date-range__footer">
      <div class="custom-date-range__actions">
        <button
          type="button"
          class="custom-date-range__btn custom-date-range__btn--reset"
          (click)="reset()"
        >
          {{ 'date_range.reset' | translateLang }}
        </button>
        <button
          type="button"
          class="custom-date-range__btn custom-date-range__btn--select"
          [disabled]="!canConfirm()"
          (click)="confirm()"
        >
          {{ 'date_range.select' | translateLang }}
        </button>
      </div>
    </div>
  </div>
</div>
